import { render } from "./Academy.vue?vue&type=template&id=2b419d48&ts=true"
import script from "./Academy.vue?vue&type=script&lang=ts"
export * from "./Academy.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__